import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Filter } from 'src/components/shared-components/class/general-classes/filter';
import { EventService } from 'src/service/event.service';
import { FilterBaseComponent } from '../filter-base-component';

@Component({
    selector: 'app-filter-time',
    templateUrl: './filter-time.component.html',
    styleUrls: ['./filter-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterTimeComponent extends FilterBaseComponent implements OnInit {
  public value: string;

  constructor(
    protected _eventService: EventService,
    protected _translateService: TranslateService
  ) {
    super(_eventService, _translateService);
  }

  ngOnInit() {
    if (this.Filter.InputValue !== "") {
      this.value = this.Filter.InputValue;
      this.valueChanged(this.value);
    }
    this.baseSubscribeTranslationEvent();
    this.baseLoadTranslation();
  }

  ngOnDestroy(): void {
    this.baseOnDestroy()
  }

  public valueChanged(event) {
    this._eventService.OnFilterValueChanged.next([
      this.Filter,
      event == null ? '' : event.toString()
    ]);
  }

}
